import React, {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {Redirect, Switch} from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import { logout } from './redux/AuthCRUD'

export function Logout() {
  const dispatch = useDispatch()
  useEffect(() => {
    try{
        logout();
    } finally{
        dispatch(auth.actions.logout())
        document.location.reload()
    }
  }, [dispatch])

  return (
    <Switch>
      <Redirect to='/login' />
    </Switch>
  )
}
